import { Box, Link } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  applyEvent,
  BillingTypeFormFacility,
  CommonOrCommonRetirementFlug,
  FormClassApply,
  InquiryCode,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_APP016_Request } from "../../type/apiType";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { TkGetCode } from "../../utils/TkGetCode";
import { httpAPI_APP016, httpAPI_REC020 } from "./api/request";
import { formHeadList, headList, headTitleList } from "./parts";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import {
  changeAmountFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import TkDataTable from "../../components/molecules/TkDataTable";
import "./_style.scss";

/**
 * SCRW160011 割増金請求
 * @return SCRW160011
 */
const SCRW160011 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [referBodyList, setReferBodyLit] = useState<any>();
  const [formTableList, setFormTableList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [bodyList, setBodyList] = useState<any>();
  const [status, setStatus] = useState<any>();
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>("1");
  const isKiKo =
    state?.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const applyId = location.state?.applyId;

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLinkClick = (invoiceId: any) => {
    setBusinessState({
      ...businessState,
      job_13: {
        ...businessState.job_13,
        demanderId: invoiceId,
        applyId: applyId,
      },
    });
    navigate("/SCRW160005");
  };

  const handleInit = async () => {
    try {
      const res = await httpAPI_REC020({
        applyId: applyId,
      });
      if (res.resultCd === "I0000") {
        // 処理履歴の表示
        const bodyListData = res.statusList?.map((item) => [
          { children: item.managerName },
          { children: item.process },
          { children: item.createDate },
          { children: item.processComment },
        ]);

        setBodyList(bodyListData ?? []);

        setStatus(res.latestApplyStatus);
        setCorpApplyKbn(res.corpApplyKbn);

        let dueDate: string = "";
        // テーブルの表示
        let tableBodyLit = res.billingDataList?.map((item: any) => {
          dueDate === "" && (dueDate = item.dueDate);
          const data = [
            {
              children: (
                <Link onClick={() => handleLinkClick(item.invoiceId)}>
                  {item.invoiceId}
                </Link>
              ),
              forSort: item.invoiceId,
            },
            {
              children: `${item.billingContractorNo}:${item.corpName}`,
            },
            {
              children: item.depositKbn
                ? TkGetCode(BillingTypeFormFacility, item.depositKbn)
                : "",
            },
            {
              children: changeAmountFormat(item.additionalAmt),
              align: "right",
            },
          ];
          return data;
        });

        let file = res.formList?.find(
          (item) => item.formClass === "RPT0102031"
        );
        //申請等状態定義の状態IDが"08"以上かつ"10"(契約者差戻し中)以外の場合、納付期限を表示
        const bodyList: any = [
          [
            {
              children: file ? (
                <TkDownloadLink
                  base64filedata={file.fileBase64 ?? ""}
                  dataname={TkGetCode(FormClassApply, file.formClass)}
                  downloadBase64={true}
                  linkDisabled={!file.fileBase64}
                />
              ) : null,
            },
            {
              children: isStatusAfterApproval(res.latestApplyStatus)
                ? res.symbolNo
                : "",
            },
            {
              children: isStatusAfterApproval(res.latestApplyStatus)
                ? res.decisionDate
                : "",
              align: "center",
            },
            {
              children: isStatusAfterApproval(res.latestApplyStatus)
                ? dueDate
                : "",
              align: "center",
            },
          ],
        ];
        setFormTableList(bodyList);

        setReferBodyLit(tableBodyLit);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const makeHttpObj = (num: string, formData?: any, date?: any) => {
    const data: any = {
      applyId: applyId,
      applyEvent: num,
      contractorNo: isKiKo
        ? businessState.common?.contractorNo
        : state.authInfo?.contractorNo,
      inquiryCode: memoCheck ? InquiryCode["契約者"] : "",
      screenId: "SCRW110001",
      reason: memoData,
    };
    if (formData) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }
    date && (data.dueDate = date);
    return data;
  };

  const callBtnEventApi = async (reqData: IAPI_APP016_Request) => {
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    const num = applyEvent[btnName];
    if (
      num !== applyEvent["受理"] &&
      num !== applyEvent["承認"] &&
      num !== applyEvent["契約者に差戻し"] &&
      num !== applyEvent["担当者に差戻し"] &&
      num !== applyEvent["課長代理確認"] &&
      num !== applyEvent["上長承認"] &&
      num !== applyEvent["郵送"]
    ) {
      return;
    }

    if (num === applyEvent["承認"]) {
      setIsOpen(true);
      return;
    }
    if (num === applyEvent["上長承認"]) {
      setOpenDate(true);
      return;
    }
    let reqData: IAPI_APP016_Request = makeHttpObj(num);
    callBtnEventApi(reqData);
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(
      applyEvent["承認"],
      formData
    );
    callBtnEventApi(reqData);
  };

  const handleJyoCyoSave = async () => {
    setOpenDate(false);
    let reqData: IAPI_APP016_Request = makeHttpObj(applyEvent["上長承認"]);
    callBtnEventApi(reqData);
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  return (
    <Box className="SCRW160011" data-testid="SCRW160011PageForTest">
      <TkKikoStepper
        applicationFlowType="TYPE2"
        businessType="JOB-13"
        corporateApplicationClassification={corpApplyKbn}
        applicationStatus={status as ITkViewButtonJudgementStatus}
      />
      <TkDataTable pagin headList={headList} bodyList={referBodyList} />
      <TkMemo
        showTable={true}
        bodyList={bodyList}
        headList={headTitleList}
        onChange={onChange}
        disabledCheckBox={false}
      />

      {isStatusAfterApproval(status) && (
        <TkTableWithNoLine bodyList={formTableList} headList={formHeadList} />
      )}

      <Box className="buttonGroup">
        <TkBackButton mr />
        <TkViewButtonJudgement
          flowType="TYPE2"
          Status={status as ITkViewButtonJudgementStatus}
          onClick={btnEvent}
        />
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW160011PageForDialog"
        open={isOpen}
        onSuccess={handleSave}
        onClose={() => setIsOpen(false)}
      />

      <TkDateDialog
        open={openDate}
        onOky={handleJyoCyoSave}
        onCancel={() => setOpenDate(false)}
        minDate={new Date()}
        maxDate={new Date("2099/12/31")}
        title="確認（上長承認）"
        contextText="　入力内容をもとに請求を行います。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRW160011;
